import React, { useState } from "react";
import { Briefcase } from "lucide-react";
import { Dropdown, DropdownToggle, DropdownMenu } from "@/design-system/native";
import styles from "./BriefCase.module.scss";
const BriefCase = () => {
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen((prev) => !prev);

  return (
    <li className={`list-unstyled header-svg-icon ${styles.item}`}>
      <Dropdown isOpen={open} toggle={toggle} direction="down">
        <DropdownToggle tag="div" className={styles.toggle}>
          <Briefcase size={21} stroke="#10161b" color="#10161b" />
        </DropdownToggle>

        <DropdownMenu
          className={styles.menu}
          modifiers={[
            { name: "offset", options: { offset: [0, 6] } },
            {
              name: "preventOverflow",
              options: { boundary: "viewport", padding: 8 },
            },
          ]}
        >
          To access your favorite clients quickly, please go to the client view
          and mark the star.
        </DropdownMenu>
      </Dropdown>
    </li>
  );
};

export default BriefCase;
